import api from "@/services/api";
import { PaginatedResponse } from "@/types";
import { CartFilters, UserCart } from "@/types/cart";

export class CartRepository {
  async findAll(filters: CartFilters): Promise<PaginatedResponse<UserCart>> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(`/v1/admin/carts?${params.toString()}`);

    return response.data as PaginatedResponse<UserCart>;
  }
}
